import 'ngstorage';

export default 'ngStorage';



// WEBPACK FOOTER //
// ./src/common/wrappers/ngstorage.js